export default function config() {
    return {
        partnerId: 1,
        apiKey: 'MDlkMzY3Nzg3MjU1ZjRkNmY4OWZjNDA0NjBjMTI0MWZl',
        clientSecret: '97D3a046BXH11FATekQWQiV33B7RCC6A8rzHvhyn',
        platform: 'web'
    };
}


// WEBPACK FOOTER //
// ./src/config.js